import { getMailListByIdFromStore, ERROR_REQUEST_CANCLE } from '@web-mail/util';
import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { sliceStateCheck, getToListAndUpdateTree, getEdmMailListReq } from '@web-mail/utils/slice';
import { asyncMailList, formateMailList, getIsSearchingMailByState, getTopMailSumHeight, mailListDiff, separateUpdateIdAndStore, } from '@web-mail/state/customize';
import { request } from '@web-mail/state/slice/request';
import { MAIL_NOTICE_BAR_HEIGHT } from '@web-mail/common/constant';
import { getIn18Text } from 'api';
import { MailListThunks } from '@web-mail/state/slice/mailReducer/listThunk';
const ReducerName = 'CustomerMailListReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'loadMailList_edm',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { noCache = false, sliceId, type } = params;
        const state = thunkAPI.getState().mailReducer;
        const _state = sliceStateCheck(state, sliceId, type);
        if (!_state) {
            return;
        }
        if (type === 'customer') {
            const isSearching = getIsSearchingMailByState(state, sliceId, type);
            let to = isSearching ? state[type][sliceId].selectedSearchContacts.list : state[type][sliceId].selectedContacts.list;
            if (to.length === 0) {
                const result = {
                    data: [],
                    total: 0,
                    query: {},
                };
                if (isSearching) {
                    return { result, params, noCache };
                }
                to = await getToListAndUpdateTree(isSearching, dispatch, state, sliceId, type);
                if (to.length === 0) {
                    return { result, params, noCache };
                }
            }
            if (to.length >= 50) {
                return Promise.reject('limit 50');
            }
            const reqParams = getEdmMailListReq(state, params, sliceId, to);
            const result = await request.doListMailBoxEntities(reqParams, noCache);
            if (result && result.data && Array.isArray(result.data)) {
                dispatch(MailListThunks.getMailListReadStatus({
                    mailIds: result.data.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; }).filter(item => item),
                    req: reqParams,
                }));
            }
            console.log('[loadMailList] customer mails', result);
            return { result, reqParams, noCache };
        }
        if (type === 'subordinate') {
            const subordinateState = _state;
            if (subordinateState.selectedFolder.subordinateId && subordinateState.selectedFolder.key) {
                const reqParams = getEdmMailListReq(state, params, sliceId);
                const result = await request.doListMailBoxEntities(reqParams, noCache);
                console.log('[loadMailList] customer mails', result);
                return { result, reqParams, noCache };
            }
        }
        const result = {
            data: [],
            total: 0,
            query: {},
        };
        return {
            result,
            params,
            noCache,
        };
    },
    pending: (state, action) => {
        const { showLoading = true, startIndex = 0, refresh, sliceId, type } = action.meta.arg || {};
        if (!sliceStateCheck(state, sliceId, type)) {
            return;
        }
        const isSearching = getIsSearchingMailByState(state, sliceId, type);
        if (startIndex === 0) {
            state[type][sliceId].scrollTop = 0;
            if (showLoading) {
                state[type][sliceId].listLoading = true;
            }
            if (!refresh) {
                if (isSearching) {
                    if (type === 'customer') {
                        state[type][sliceId].searchList = [];
                        state[type][sliceId].selectedMailId = {
                            id: '',
                        };
                    }
                }
                else {
                    state[type][sliceId].mailDataList = [];
                    state[type][sliceId].selectedMailId = {
                        id: '',
                    };
                }
            }
        }
    },
    fulfilled: (state, action) => {
        var _a;
        const res = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.result;
        const { startIndex = 0, showLoading = true, refresh, sliceId, type } = action.meta.arg || {};
        if (!sliceStateCheck(state, sliceId, type)) {
            return;
        }
        const isSearching = getIsSearchingMailByState(state, sliceId, type);
        const oldMailDataList = [...state[type][sliceId].mailDataList];
        state[type][sliceId].mailListInitIsFailed = false;
        state[type][sliceId].listLoading = false;
        if (!(res === null || res === void 0 ? void 0 : res.query) || !(res === null || res === void 0 ? void 0 : res.data)) {
            showLoading && reduxMessage.error({ content: getIn18Text('FUWUDUANWEIFAN') });
            state[type][sliceId].mailListInitIsFailed = true;
            return;
        }
        const totalKeys = isSearching && type === 'customer' ? 'searchTotal' : 'mailTotal';
        const listKey = isSearching && type === 'customer' ? 'searchList' : 'mailDataList';
        state[type][sliceId][totalKeys] = res.total >= 0 ? res.total : 0;
        let list = startIndex === 0 ? [] : getMailListByIdFromStore(state[type][sliceId][listKey], state.mailEntities);
        list = list.length > 0 ? asyncMailList(list, res.data) : res.data;
        separateUpdateIdAndStore(state, listKey, formateMailList(list), {
            key: listKey,
            exclude: ['receiver'],
            sliceId,
            type,
        });
        if (refresh) {
            state[type][sliceId].refreshBtnLoading = false;
            if (!isSearching) {
                const newMailDataList = res.data.map(mail => { var _a; return mail.id || ((_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id); });
                state[type][sliceId].refreshHasNewMail = newMailDataList.some(id => !oldMailDataList.includes(id));
            }
        }
    },
    rejected: (state, action) => {
        var _a;
        const { showLoading = true, refresh, sliceId, type } = (action.meta.arg || {});
        if (!sliceStateCheck(state, sliceId, type)) {
            return;
        }
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.warn('[loadMailList] customer mails rejected', error);
        if (error !== ERROR_REQUEST_CANCLE) {
            state[type][sliceId].listLoading = false;
            if (refresh) {
                state[type][sliceId].refreshBtnLoading = false;
            }
            if ((error === null || error === void 0 ? void 0 : error.code) === 'FA_NEED_AUTH2') {
                state[type][sliceId].mailDataList = [];
            }
            else {
                state[type][sliceId].mailListInitIsFailed = true;
                if (error === 'limit 50') {
                    reduxMessage.error({ content: getIn18Text('KEHUXIALIANXIRGD，QDJJTLXRCK') });
                }
                else {
                    showLoading && reduxMessage.error({ content: getIn18Text('JIAZAISHIBAI') });
                }
            }
        }
    },
});
thunkHelper({
    name: 'loadMailListFromDB_edm',
    request: async (params, thunkAPI) => {
        console.log('[loadMailListFromDB edm]', params);
        const { sliceId, type } = params;
        const state = thunkAPI.getState().mailReducer;
        if (!sliceStateCheck(state, sliceId, type)) {
            return;
        }
        const { mailDataList } = state[type][sliceId];
        const reqParams = getEdmMailListReq(state, params, sliceId);
        reqParams.count = mailDataList && mailDataList.length ? mailDataList.length : 100;
        if (reqParams.count < 30) {
            reqParams.count = 30;
        }
        if (reqParams.count > 500) {
            reqParams.count = 500;
        }
        const result = await request.doListMailBoxEntitiesFromDB(reqParams);
        console.log('[loadMailListFromDB edm] mails', result);
        return result;
    },
    pending: (state, action) => {
        const { showLoading = true, startIndex = 0, sliceId, type } = (action.meta.arg || {});
        if (!sliceStateCheck(state, sliceId, type)) {
            return;
        }
        if (showLoading && startIndex === 0) {
            state[type][sliceId].listLoading = true;
        }
    },
    fulfilled: (state, action) => {
        const { sliceId, type } = action.meta.arg || {};
        const res = action.payload;
        if (!sliceStateCheck(state, sliceId, type)) {
            return;
        }
        const mailDataList = getMailListByIdFromStore(state[type][sliceId].mailDataList, state.mailEntities);
        state[type][sliceId].mailListInitIsFailed = false;
        if (res) {
            if (!res.query || !res.data) {
                console.warn('[loadMailListFromDB edm] error');
                return;
            }
            if (res.data.length >= 500 && mailDataList.length > res.data.length) {
                try {
                    const list = conactMailList(mailDataList, res.data);
                    state[type][sliceId].mailDataList = formateMailList(list).map(v => v.id);
                    state[type][sliceId].mailTotal = res.total >= 0 ? res.total : 0;
                    state[type][sliceId].listLoading = false;
                }
                catch (e) {
                    console.warn('[loadMailListFromDB edm] error', e);
                }
            }
            else {
                separateUpdateIdAndStore(state, 'mailDataList', formateMailList(res.data), {
                    key: 'mailDataList_cm',
                    exclude: ['receiver'],
                    sliceId,
                    type,
                });
                state[type][sliceId].mailTotal = res.total >= 0 ? res.total : 0;
                state[type][sliceId].listLoading = false;
            }
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        const { showLoading = true, sliceId, type } = (action.meta.arg || {});
        if (!sliceStateCheck(state, sliceId, type)) {
            return;
        }
        if (error !== ERROR_REQUEST_CANCLE) {
            state[type][sliceId].listLoading = false;
            if ((error === null || error === void 0 ? void 0 : error.code) === 'FA_NEED_AUTH2') {
                state[type][sliceId].mailDataList = [];
            }
            else {
                state[type][sliceId].mailListInitIsFailed = true;
                showLoading && reduxMessage.error({ content: getIn18Text('JIAZAISHIBAI') });
            }
        }
        console.warn('MailListError', 'loadMailListFromDB edm rejected', error);
    },
});
thunkHelper({
    name: 'pullLastMail_cm',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { noCache = true, sliceId } = params;
        console.log('[pullLastMail_cm] request', params);
        const state = thunkAPI.getState().mailReducer;
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        const isSearching = getIsSearchingMailByState(state, sliceId, 'customer');
        let to = isSearching ? state.customer[sliceId].selectedSearchContacts.list : state.customer[sliceId].selectedContacts.list;
        if (to.length === 0) {
            const result = {
                data: [],
                total: 0,
                query: {},
            };
            if (isSearching) {
                return { result, params, noCache };
            }
            to = await getToListAndUpdateTree(isSearching, dispatch, state, sliceId, 'customer');
            if (to.length === 0) {
                return { result, params, noCache };
            }
        }
        const reqParams = getEdmMailListReq(state, params, sliceId, to);
        const result = await request.doListMailBoxEntities(reqParams, noCache);
        console.log('[pullLastMail_cm] customer mails', result);
        return { result, reqParams, noCache };
    },
    fulfilled: (state, action) => {
        var _a, _b;
        const { sliceId } = action.meta.arg || {};
        const res = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.result;
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        const isSearching = getIsSearchingMailByState(state, sliceId, 'customer');
        if ((res === null || res === void 0 ? void 0 : res.data) && ((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.length) && !isSearching) {
            const { mailTotal, scrollTop } = state.customer[sliceId];
            const mailDataList = getMailListByIdFromStore(state.customer[sliceId].mailDataList, state.mailEntities);
            const _res = res.data;
            if (state.customer[sliceId].mailDataList.length <= 30 ||
                (state.customer[sliceId].scrollTop <= 100 && state.customer[sliceId].activeIds && state.customer[sliceId].activeIds.length > 1)) {
                separateUpdateIdAndStore(state, 'mailDataList', formateMailList(_res), {
                    key: 'mailList_cm',
                    exclude: ['receiver'],
                    sliceId,
                    type: 'customer',
                });
                state.customer[sliceId].mailTotal = mailTotal;
            }
            else {
                const diffParams = mailListDiff(_res, mailDataList);
                const topMailSumHeight = getTopMailSumHeight(mailDataList);
                if (diffParams != null) {
                    const { sumHeight, sumNewMail, insertPosi } = diffParams;
                    const _mailDatalist = [..._res.slice(0, insertPosi), ...mailDataList.slice(insertPosi)];
                    if (scrollTop > topMailSumHeight + MAIL_NOTICE_BAR_HEIGHT) {
                        state.customer[sliceId].scrollTop = scrollTop + sumHeight;
                    }
                    else {
                        state.customer[sliceId].scrollTop =
                            state.customer[sliceId].scrollTop % 2 === 0 ? state.customer[sliceId].scrollTop + 1 : state.customer[sliceId].scrollTop - 1;
                    }
                    state.customer[sliceId].mailTotal = mailTotal + sumNewMail;
                    separateUpdateIdAndStore(state, 'mailDataList', formateMailList(_mailDatalist), {
                        key: 'mailDataList_cm',
                        exclude: ['receiver'],
                        sliceId,
                        type: 'customer',
                    });
                }
            }
        }
    },
});
export const MailListThunks_cm = Thunks;
export const MailListExtraReducersList_cm = ReducersList;
